import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../store/services/session.service';
import { IUserSessionData } from '../../store/models/user.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { Button, ButtonColor, ButtonSize } from '../../store/models/button.model';
import { UserService } from '../../store/services/user.service';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { openSnackbar } from '../../store/actions/page.action';
import { Router } from '@angular/router';
import { setSmsDetails } from '../../store/actions/user.action';

@Component({
  selector: 'app-set-sms-details',
  templateUrl: './set-sms-details.component.html',
  styleUrls: ['./set-sms-details.component.scss']
})
export class SetSmsDetailsComponent implements OnInit {

  userData: IUserSessionData;
  formGroup;

  buttonProperties: Button = {
    text: 'Save',
    color: ButtonColor.ORANGE,
    style: 'rounded',
    onClick: () => {

      if(!this.formGroup.valid) {
        this.formGroup.markAsTouched();
        return;
      }

      this.userService.updateUserSmsDetails(
        this.userData.id,
        this.formGroup.get('send_sms').value,
        this.formGroup.get('mobile_phone').value.e164Number
      ).subscribe(() => {
        this.store$.dispatch(setSmsDetails({
          sendSms: this.formGroup.get('send_sms').value,
          mobilePhone: this.formGroup.get('mobile_phone').value.e164Number
        }));
        this.store$.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: 'SMS details were saved successfully!',
              type: 'success',
            }
          }
        }));
        this.router.navigate(['/messages']);
      }, err => this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: err.error,
            type: 'error'
          }
        }
      })));
    }
  }

  constructor(
    private readonly sessionService: SessionService,
    private readonly userService: UserService,
    private readonly store$: Store<IReducers>,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.sessionService.onReady().subscribe(
      user => {
        this.userService.getAccountInf(user.id).subscribe(
          userInfo => {
            this.formGroup = new FormGroup({
              send_sms: new FormControl(!!user.send_sms, [Validators.required]),
              mobile_phone: new FormControl(userInfo.mobile_phone, [Validators.required])
            })
            this.userData = user;
          }
        )

      },
    )
  }

  readonly CountryISO = CountryISO;
  readonly PhoneNumberFormat = PhoneNumberFormat;
}
1
